import React, { Component } from 'react';
import { Container, Row, Col, Card, Button, CardImg, CardTitle, CardText,
    CardSubtitle, CardBlock } from 'reactstrap';
import Perro from '../../../public/chihuahua.jpg';

export default class Blog extends Component {
  render() {
    return (
        <Container>
          <Row>
            <Col xs="9">
                <Card>
                  <CardImg top width="200px" height="190px" src={Perro} alt="Card image cap"/>
                  <CardBlock>
                    <CardTitle>Labrador</CardTitle>
                    <CardSubtitle>Raza Mediana</CardSubtitle>
                    <CardText>El Labrador retriever —también conocido como Cobrador de Labrador o Perdiguero
                      de Labrador — es una raza canina originaria de Terranova, en la actual Canadá. Es la
                      raza más popular del mundo por la cantidad de ejemplares registrados</CardText>
                    <Button>Leer más</Button>
                  </CardBlock>
                </Card>
            </Col>
            <Col>
              <Card block inverse style={{backgroundColor: '#009688', borderColor: '#999'}}>
                <CardTitle>Sabias Que?</CardTitle>
                <CardText>LOS PERROS SÓLO SUDAN POR LAS ALMOHADILLAS DE LAS PATAS.</CardText>
              </Card>
            </Col>
          </Row>
        </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Blog/index.js